"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOTIFI_CONFIGS = void 0;
exports.NOTIFI_CONFIGS = {
    Production: {
        gqlUrl: 'https://api.notifi.network/gql',
        storagePrefix: 'notifi-jwt',
    },
    Staging: {
        gqlUrl: 'https://api.stg.notifi.network/gql',
        storagePrefix: 'notifi-jwt:stg',
    },
    Development: {
        gqlUrl: 'https://api.dev.notifi.network/gql',
        storagePrefix: 'notifi-jwt:dev',
    },
    Local: {
        gqlUrl: 'https://localhost:5001/gql',
        storagePrefix: 'notifi-jwt:local',
    },
};
const notifiConfigs = (environment) => {
    return exports.NOTIFI_CONFIGS[environment];
};
exports.default = notifiConfigs;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibm90aWZpQ29uZmlncy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL2xpYi91dGlscy9ub3RpZmlDb25maWdzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQVdhLFFBQUEsY0FBYyxHQUFpRDtJQUMxRSxVQUFVLEVBQUU7UUFDVixNQUFNLEVBQUUsZ0NBQWdDO1FBQ3hDLGFBQWEsRUFBRSxZQUFZO0tBQzVCO0lBQ0QsT0FBTyxFQUFFO1FBQ1AsTUFBTSxFQUFFLG9DQUFvQztRQUM1QyxhQUFhLEVBQUUsZ0JBQWdCO0tBQ2hDO0lBQ0QsV0FBVyxFQUFFO1FBQ1gsTUFBTSxFQUFFLG9DQUFvQztRQUM1QyxhQUFhLEVBQUUsZ0JBQWdCO0tBQ2hDO0lBQ0QsS0FBSyxFQUFFO1FBQ0wsTUFBTSxFQUFFLDRCQUE0QjtRQUNwQyxhQUFhLEVBQUUsa0JBQWtCO0tBQ2xDO0NBQ0YsQ0FBQztBQUVGLE1BQU0sYUFBYSxHQUFHLENBQUMsV0FBOEIsRUFBcUIsRUFBRTtJQUMxRSxPQUFPLHNCQUFjLENBQUMsV0FBVyxDQUFDLENBQUM7QUFDckMsQ0FBQyxDQUFDO0FBRUYsa0JBQWUsYUFBYSxDQUFDIn0=